export default "__VITE_ASSET__Dr6Nbh51__"